import { getUrlParam, geVersion, executeProtocol } from '_lib/utils';

function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    callback();
    return;
  }
  if (window.WVJBCallbacks) {
    window.WVJBCallbacks.push(callback);
    return;
  }
  window.WVJBCallbacks = [callback];
  executeProtocol({ protocol_type: 'injectBridgeJS' });
}
// 客户端在293版本支持通过jsBridge调用这些方法，剩下的会在297带上
const CALLBACK_CAN_USE_293 = [
  'pageVisibleFromBackend',
  'pageVisibleFromOthersPage',
  'pageHiddenToBackend',
  'pageHiddenToOthersPage',
  'getScreenshotRect',
  'loadingFinished',
];
// 注册JsBridge回调
export function registerNativeCallback(callbackName, callback) {
  const isMax =
    getUrlParam('client_type') == 'maxjia' || getUrlParam('x_app') == 'maxjia';
  if (!geVersion('1.3.293') || (isMax && !geVersion('5.0.293'))) {
    window[callbackName] = callback;
  } else {
    // 297版本以下用老的注册方式，在web调用callback。297版本以上用新的注册方式，在客户端调用callback
    if (!geVersion('1.3.298') || (isMax && !geVersion('5.0.298'))) {
      if (!CALLBACK_CAN_USE_293.includes(callbackName)) {
        window[callbackName] = callback;
      } else {
        const registerFunc = (data, responseCallback) => {
          let v = callback(data);
          responseCallback && responseCallback(v);
        };
        setupWebViewJavascriptBridge(() =>
          window.WebViewJavascriptBridge.registerHandler(
            callbackName.replace(/\(|\)/g, ''),
            registerFunc,
          ),
        );
      }
    } else {
      setupWebViewJavascriptBridge(() =>
        window.WebViewJavascriptBridge.registerHandler(
          callbackName.replace(/\(|\)/g, ''),
          callback,
        ),
      );
    }
  }
}
